import { z } from 'zod';
import { Fiche, Language, TemplateId } from './fiche.js';
import { Patch } from './patch.js';

export const ExtractRequest = z.object({
  blob: z.string().min(1).max(2_000_000),
  language: Language,
  template_hint: TemplateId.optional(),
  source_summary: z
    .array(
      z.object({
        kind: z.enum(['pdf', 'image', 'text']),
        label: z.string(),
        extracted_chars: z.number(),
      }),
    )
    .default([]),
});
export type ExtractRequest = z.infer<typeof ExtractRequest>;

export const ExtractResponse = z.object({
  data: Fiche,
  model_used: z.string(),
  latency_ms: z.number(),
});
export type ExtractResponse = z.infer<typeof ExtractResponse>;

export const PatchRequest = z.object({
  fiche: Fiche,
  prompt: z.string().min(1).max(2000),
  target_section_id: z.string().optional(),
  target_bullet_id: z.string().optional(),
  language: Language,
});
export type PatchRequest = z.infer<typeof PatchRequest>;

export const PatchResponse = z.object({
  data: Patch,
  model_used: z.string(),
  latency_ms: z.number(),
});
export type PatchResponse = z.infer<typeof PatchResponse>;

export const ApiError = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
  }),
});
export type ApiError = z.infer<typeof ApiError>;
